export default __webpack_public_path__ + "static/media/lc.a81dd120.svg";